"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStepProps = exports.useStepperState = void 0;
var react_1 = require("react");
function useStepperState(initialCurrStep) {
    if (initialCurrStep === void 0) { initialCurrStep = 0; }
    var _a = react_1.useState(initialCurrStep), currentStep = _a[0], setCurrentStep = _a[1];
    var nextStep = function () { return setCurrentStep(function (step) { return step + 1; }); };
    var previousStep = function () { return setCurrentStep(function (step) { return step - 1; }); };
    return {
        getStepProps: function (step) { return getStepProps(step, currentStep); },
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        nextStep: nextStep,
        previousStep: previousStep,
    };
}
exports.useStepperState = useStepperState;
/**
 * Create a StepProps properties object to pass to a Step component, based on its index and current Stepper state.
 *
 * @param step The step index that will receive the props.
 * @param currentActiveStep The current active stepper step.
 */
function getStepProps(step, currentActiveStep) {
    return {
        status: (step < currentActiveStep && 'completed') || (step > currentActiveStep && 'incompleted') || 'active',
        hasConnector: step > 0,
    };
}
exports.getStepProps = getStepProps;
//# sourceMappingURL=useStepperState.js.map